<template>
  <div
    class="header-address-bar"
  >
    <div class="bar-l">
      <div class="text">
        Cart
      </div>
      <div class="counts">
        {{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}
      </div>
    </div>
    <div
      class="bar-r"
    >
      <div class="ship-to">
        <Icon
          class="icon"
          name="global-delivery-l"
        />
        Shipping to
      </div>
      <div
        class="address-info"
        @click="handleAddressClick"
      >
        <Icon
          class="icon"
          name="location-l"
        />
        <div
          class="address"
          v-if="addressStore.cacheAddress"
        >
          {{ `${ addressStore.cacheAddress.city }, ${ addressStore.cacheAddress.province }, ${ addressStore.cacheAddress.country }` }}
        </div>
        <div
          class="add"
          v-else
        >
          <img :src="countryUrl">
          Add new address
        </div>
        <Icon
          class="arrow"
          name="arrow-right-l-2"
        />
      </div>
    </div>
  </div>
  <div class="line" />
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { useAddressStore } from '@/pinia/address'
import { useCartStore } from '@/pinia/cart'
import { useShipStore } from '@/pinia/ship'
import { buriedPointUtil } from '@/utils/utils'

const addressStore = useAddressStore()

const cartStore = useCartStore()

const ship = useShipStore()

const countryUrl = computed(() => ship.country.countryUrl)

onBeforeMount(() => {
  /**
   * 更新最新的购物车数量，防止出现数量不同步的情况
   */
  cartStore.updateCartCount()
})

const handleAddressClick = () => {
  buriedPointUtil({ eventId: 'PCL201' })
  addressStore.show(3)
}
</script>

<style lang='less' scoped>
.header-address-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
  margin-top: 24px;

  .bar-l {
    display: flex;
    align-items: center;
    gap: 6px;
    .text {
      color: #232323;
      font-size: 20px;
      font-family: mon-700;
    }
    .counts {
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background-color: #009de0;
      border-radius: 50%;
      color: white;
      font-size: 12px;
      font-family: mon-600;
    }
  }
  .bar-r {
    display: flex;
    align-items: center;
    gap: 8px;
    .ship-to {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #232323;
      font-size: 12px;
      font-family: mon-600;
      height: 16px;
      .icon {
        font-size: 18px;
      }
    }
    .address-info {
      display: flex;
      align-items: center;
      height: 24px;
      background-color: #f8f8f8;
      border-radius: 2px;
      border: 1px solid #ebf1f5;
      padding: 0 8px;
      cursor: pointer;

      .icon {
        margin-right: 1px;
        font-size: 12px;
      }
      .address {
        color: #232323;
        font-size: 11px;
        font-family: mon-500;
        margin: 0 2px 0 2px;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .add {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: mon-500;
        font-size: 11px;
        line-height: 14px;

        > img {
          width: 14px;
          object-fit: contain;
        }
      }
      .arrow {
        margin-left: 4px;
        font-size: 14px;
      }
    }
  }
}

.line {
  margin-top: 16px;
  height: 1px;
  background-color: #ebf1f5;
}

.skeleton-warpper {
  display: flex;
  justify-content: space-between;
  height: 28px;
  margin-top: 24px;

  .skeleton-l {
    display: flex;
    align-items: center;
    gap: 6px;
    .text {
      color: #232323;
      font-size: 20px;
      font-family: mon-700;
    }
    .circle {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
    }
  }
  .skeleton-r {
    width: 248px;
    height: 24px;
    border-radius: 2px;
    animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
  }
}

@keyframes skeleton {
  0% {
    background-color: #EBEBEB;
  }
  25% {
    background-color: #F8F8F8;
  }
  80% {
    background-color: #EBEBEB;
  }
  100% {
    background-color: #EBEBEB;
  }
}
</style>
